import React, { useState, useCallback, useEffect } from "react";
import { Grid, Button, Box, Typography, Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import userApi from "../../services/user";
import { useDispatch, useSelector } from "react-redux";
import { showLoader, hideLoader } from "../../redux/loader/actions";
import Creation from "./creation";
import List from "./list";

const useStyles = makeStyles({
  animatedButton: {
    background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
    color: "#fff",
    padding: "10px 30px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "5px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
    },

    "@media (max-width: 600px)": {
      width: "100%",
      padding: "12px 4px",
      fontSize: "12px",
    },
  },
  chip: {
    marginRight: "16px",
  },
});

const Vendor = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const menuItems = useSelector((state) => state.menuReducer.items);
  const createMenuItem = menuItems?.find(
    (item) => item.name.toLowerCase() === "vendor"
  );
  const isDisabled = createMenuItem?.access_type === "read_write";

  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <Grid item xs={12} sm={10} mb={2}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Vendor</Typography>
          <Box display="flex" alignItems="center">
            {/* {isDisabled && ( */}
              <Button
                variant="contained"
                className={classes.animatedButton}
                onClick={() => setOpenModal(true)}
              >
                Add Vendor
              </Button>
            {/* )} */}
          </Box>
        </Box>
      </Grid>
      <Creation open={openModal} onClose={() => setOpenModal(false)} />
      <List />
    </>
  );
};

export default Vendor;
